/* unplugin-vue-components disabled */import { render } from "./MossAnswerOption.vue?vue&type=template&id=7867beec&scoped=true"
import script from "./MossAnswerOption.vue?vue&type=script&lang=js"
export * from "./MossAnswerOption.vue?vue&type=script&lang=js"

import "./MossAnswerOption.vue?vue&type=style&index=0&id=7867beec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7867beec"]])

export default __exports__